import { Search } from "@mui/icons-material";
import { InputAdornment, Paper, TextField } from "@mui/material";
import { GridColDef, DataGrid, GridRowSelectionModel } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { formatPhoneNumber } from "../../utils/formatPhoneNumber";
import "./styles.scss";
import { ClientReportType } from "../../types/genericType";

type ClientsTableProps = {
  data: Array<ClientReportType>;
  setRowSelectionModel: Function;
  rowSelectionModel: GridRowSelectionModel | undefined;
};

const ClientsReportTable = (props: ClientsTableProps) => {
  const { data, rowSelectionModel, setRowSelectionModel } = props;
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredRows, setFilteredRows] = useState(data);

  const handleSearch = (event: any) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);

    const filteredData = data.filter((row: any) =>
      Object.values(row).some(
        (value) =>
          typeof value === "string" && value.toLowerCase().includes(term)
      )
    );
    setFilteredRows(filteredData);
  };

  useEffect(() => {
    setFilteredRows(data);
  }, [data]);

  const columns: GridColDef[] = React.useMemo<GridColDef[]>(
    () => [
      {
        field: "lastName",
        headerName: "Last Name",
        hideable: false,
        minWidth: 130,
        headerClassName: "header-datagrid",
      },
      {
        field: "firstName",
        headerName: "First Name",
        hideable: false,
        minWidth: 130,
        headerClassName: "header-datagrid",
        sortable: false,
      },
      {
        field: "accountNumber",
        headerName: "Acct#",
        hideable: false,
        minWidth: 100,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "accountName",
        headerName: "Acct. Name",
        hideable: false,
        minWidth: 160,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "userEmail",
        headerName: "User Email",
        hideable: false,
        minWidth: 180,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "clientEmail",
        headerName: "Client Email",
        hideable: false,
        minWidth: 180,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "accountEmail",
        headerName: "Account Email",
        hideable: false,
        minWidth: 180,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "companyName",
        headerName: "Company",
        hideable: false,
        minWidth: 160,
        headerClassName: "header-datagrid",
        sortable: false,
      },
      {
        field: "status",
        headerName: "Status",
        hideable: false,
        minWidth: 100,
        sortable: false,
        headerClassName: "header-datagrid",
        valueGetter: (params) => {
          return params.row.isActive ? "Active" : "Inactive";
        },
      },
      {
        field: "type",
        headerName: "Acct Type",
        hideable: false,
        minWidth: 100,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "phoneNumber",
        headerName: "Phone Number",
        hideable: false,
        minWidth: 150,
        sortable: false,
        headerClassName: "header-datagrid",
        valueGetter: (params) => {
          return formatPhoneNumber(params.row.phoneNumber);
        }
      },
      //commented maybe add later
      // {
      //   field: "taxNumber",
      //   headerName: "TIN",
      //   hideable: false,
      //   minWidth: 120,
      //   sortable: false,
      //   headerClassName: "header-datagrid",
      // },
    ],
    []
  );

  return (
    <Paper elevation={3} className="users-table">
      <TextField
        label="Search"
        variant="outlined"
        size="small"
        className="search-field"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleSearch}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
      />
      {filteredRows.length > 0 ? (
        <DataGrid
          checkboxSelection
          rows={filteredRows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[10, 20, 30, 40, 50]}
          className="datagrid"
          onRowSelectionModelChange={(newRowSelectionModel) => {
            setRowSelectionModel(newRowSelectionModel);
          }}
          rowSelectionModel={rowSelectionModel}
          getRowId={(row) => row.clientId}
        />
      ) : (
        <div className="no-results">No results found</div>
      )}
    </Paper>
  );
};

export default ClientsReportTable;
